import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { useTranslations } from 'next-intl';

import { $api, errorHandler } from 'modules/global';

export const useBuyPremium = () => {
  const t = useTranslations();

  return useMutation({
    mutationFn: async (application: {
      type?: string | null;
      month_count?: number;
      platform?: string;
      phone?: string;
    }) => {
      const { data } = await $api.post('/buy-premium', undefined, { params: application });

      return data;
    },
    onSuccess: data => {
      if (data === true) {
        return message.success(t('bu_tarif_allaqachon_sotib_olingan'));
      }
      message.success(t('Muvaffaqiyatli_bajarildi'));
      return window.open(data, '_self');
    },
    onError: errorHandler()
  });
};
